import { Component, OnInit, ViewChild } from "@angular/core";
import { NotificacaoService } from "../../services/notificacao.service";
import { CarregandoService } from "../../services/carregando.service";
import { MatDialog, MatDialogRef, MatPaginator, PageEvent } from "@angular/material";
import { PaginatorService } from "../../services/paginator.service";
import { ExcecaoIndicadorAnaliseDesconto, IndicadorAnaliseDesconto } from "../../models/indicador-analise-desconto";
import { IndicadorAnaliseDescontoService } from "../../services/indicador-analise-desconto.service";
import { Filtro } from "../../models/filtro";
import { PerfectScrollbarConfigInterface } from "ngx-perfect-scrollbar";
import { Produto } from "src/app/models/produto";
import { ProdutoService } from "src/app/services/produto.service";
import { SelecionaProdutoV2ModalComponent } from "../seleciona-produto-v2-modal/seleciona-produto-v2-modal.component";
import swal from "sweetalert2";
import { PremissasSistema } from "../../models/premissas-sistema";
import { PremissasService } from "../../services/premissas.service";
import { TipoFiltroProduto } from "../../models/enum";
import { SelecionaProdutoModalComponent } from "../seleciona-produto-modal/seleciona-produto-modal.component";

declare const $: any;

@Component({
  selector: 'app-indicadores-analise-desconto-modal',
  templateUrl: './indicadores-analise-desconto-modal.component.html',
  styleUrls: ['./indicadores-analise-desconto-modal.component.scss']
})
export class IndicadoresAnaliseDescontoModalComponent implements OnInit {
  indicadores: IndicadorAnaliseDesconto[] = [];
  excecoes: ExcecaoIndicadorAnaliseDesconto[] = [];

  campoOrdenacao = 'de';
  ordenarDesc = false;
  editavel = true;
  paginacao;
  listaDeItensPorPagina;
  itensPorPagina;
  filtroNome: Filtro = { Propriedade: 'descri', Valor: '' };
  filtros: Filtro[] = [this.filtroNome];
  paineis: Produto[] = [];
  novaExcecao: ExcecaoIndicadorAnaliseDesconto;

  premissasSistema: PremissasSistema = new PremissasSistema();

  @ViewChild('paginator', { static: false }) paginator: MatPaginator;

  public config: PerfectScrollbarConfigInterface = {};

  constructor(
    private notificacaoService: NotificacaoService,
    private carregandoService: CarregandoService,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<IndicadoresAnaliseDescontoModalComponent>,
    private paginatorService: PaginatorService,
    private indicadorService: IndicadorAnaliseDescontoService,
    private produtoService: ProdutoService,
    private premissasService: PremissasService
  ) { }

  ngOnInit() {
    const pagination = this.paginatorService.consultarPaginacao();

    this.paginacao = pagination.paginacao;
    this.itensPorPagina = pagination.itensPorPagina;
    this.listaDeItensPorPagina = pagination.listaDeItensPorPagina;

    this.buscarPremissasSistema().then();
    this.buscarIndicadores();
    this.buscarExcecoes();
    this.buscarPaineis();
  }

  async buscarPremissasSistema() {
    try {
      this.carregandoService.mostra('buscarPremissasSistema');
      this.premissasSistema = await this.premissasService.consultarPremissasSistema().toPromise();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarPremissasSistema');
    }
  }

  buscarIndicadores() {
    this.carregandoService.mostra('buscarIndicadores');
    this.indicadorService.consultarLista().subscribe(dados => {
      if (dados) {
        this.indicadores = dados;
      } else {
        this.indicadores = [
          { id: 0, descricao: 'Bloqueio Automático da Autorização', de: -100, ate: 1.20, cor: 'vermelho', editando: false },
          { id: 0, descricao: 'Permite a aprovação, mas exige o anexo do orçamento do concorrente e uma justificativa descritiva', de: 1.201, ate: 1.301, cor: 'amarelo', editando: false },
          { id: 0, descricao: 'Liberação imediata para execução', de: 1.302, ate: 100, cor: 'verde', editando: false }
        ];

        this.indicadores.forEach(i => {
          this.salvar(i, true, this.indicadores);
        });
      }
      this.carregandoService.esconde('buscarIndicadores');
    }, (erro) => {
      this.notificacaoService.erro(erro);
      this.carregandoService.esconde('buscarIndicadores');
    });
  }

  buscarExcecoes() {
    this.carregandoService.mostra('buscarExcecoes');
    this.indicadorService.buscarExcecoes().subscribe(dados => {
      this.excecoes = dados;
      this.carregandoService.esconde('buscarExcecoes');
    }, (erro) => {
      this.notificacaoService.erro(erro);
      this.carregandoService.esconde('buscarExcecoes');
    });
  }

  buscarPaineis() {
    this.carregandoService.mostra('buscaPaineis');

    this.produtoService.buscarPaineis().subscribe(
      (pa) => {
        this.paineis = pa;
        this.carregandoService.esconde('buscaPaineis');
      },
      (erro) => {
        this.carregandoService.esconde('buscaPaineis');
      }
    );
  }

  ordena(campo) {
    if (campo) {
      this.campoOrdenacao = campo;
      this.ordenarDesc = !this.ordenarDesc;

      this.mudaDePagina({ length: this.paginator.length, pageIndex: this.paginator.pageIndex, pageSize: this.paginator.pageSize });
    }

    return false;
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    if (typeof a === 'string') {
      a = a.toLowerCase();
    }

    if (typeof b === 'string') {
      b = b.toLowerCase();
    }

    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  filtra() {
    this.buscarIndicadores();
    this.paginator.firstPage();
  }

  mudaDePagina(pageEvent: PageEvent) {
    if (this.itensPorPagina !== pageEvent.pageSize)
      this.paginatorService.salvaPaginacao(pageEvent.pageSize);

    this.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.buscarIndicadores();
  }

  editarIndicador(indicador: IndicadorAnaliseDesconto) {
    this.indicadores.forEach(i => i.editando = false); // só permite um por vez
    indicador.editando = true;
    indicador.deAnterior = indicador.de;
    indicador.ateAnterior = indicador.ate;
  }

  cancelarEdicaoIndicador(indicador: IndicadorAnaliseDesconto) {
    indicador.editando = false;
    indicador.de = indicador.deAnterior;
    indicador.ate = indicador.ateAnterior;
  }

  salvarIndicador(indicador: IndicadorAnaliseDesconto) {
    if (this.validarFaixas(this.indicadores)) {
      indicador.editando = false;

      if (indicador.id !== 0) {
        this.salvar(indicador, false, this.indicadores);
      }
    } else {
      alert('As faixas não podem se sobrepor!');
    }
  }

  salvarIndicadorExcecao(indicador: IndicadorAnaliseDesconto, indicadores: IndicadorAnaliseDesconto[]) {
    if (this.validarFaixas(indicadores)) {
      indicador.editando = false;

      if (indicador.id !== 0) {
        this.salvar(indicador, false, indicadores);
      }
    } else {
      alert('As faixas não podem se sobrepor!');
    }
  }

  salvarExcecao() {
    if (!this.validarFaixas(this.novaExcecao.indicadores)) return;

    this.carregandoService.mostra('salvarExcecao');
    this.indicadorService.salvarExcecao(this.novaExcecao).subscribe(
      () => {
        this.carregandoService.esconde('salvarExcecao');
        this.notificacaoService.sucesso('Exceção salva com sucesso!');
        this.limparExcecao();
        this.buscarExcecoes();
      },
      err => {
        this.carregandoService.esconde('salvarExcecao');
        this.notificacaoService.erro(err);
      }
    );
  }

  limparExcecao() {
    this.novaExcecao = undefined;
  }

  salvar(item: IndicadorAnaliseDesconto, criando: boolean = false, indicadores: IndicadorAnaliseDesconto[]) {
    if (!this.validarFaixas(indicadores)) return;

    this.carregandoService.mostra('salvar');
    this.indicadorService.salvar(item).subscribe(
      () => {
        this.carregandoService.esconde('salvar');

        if (!criando)
          this.notificacaoService.sucesso('Faixa salva com sucesso!');
        item.editando = false;
      },
      err => {
        this.carregandoService.esconde('salvar');
        this.notificacaoService.erro(err);
      }
    );
  }

  validarFaixas(indicadores: IndicadorAnaliseDesconto[]): boolean {
    for (let i = 0; i < indicadores.length; i++) {
      for (let j = i + 1; j < indicadores.length; j++) {
        if (!(indicadores[i].ate < indicadores[j].de ||
          indicadores[j].ate < indicadores[i].de)) {
          return false;
        }
      }
    }
    return true;
  }

  excluirExcecao(excecao: ExcecaoIndicadorAnaliseDesconto) {
    this.carregandoService.mostra('excluirExcecao');

    this.indicadorService.excluirExcecao(excecao.idProduto).subscribe(
      () => {
        this.buscarExcecoes();
        this.carregandoService.esconde('excluirExcecao');
      },
      err => {
        this.carregandoService.esconde('excluirExcecao');
        this.notificacaoService.erro(err);
      }
    );
  }

  excluir(item: IndicadorAnaliseDesconto) {
    this.carregandoService.mostra('excluirItem');

    this.indicadorService.excluir(item.id).subscribe(
      () => {
        this.buscarIndicadores();
        this.carregandoService.esconde('excluirItem');
      },
      err => {
        this.carregandoService.esconde('excluirItem');
        this.notificacaoService.erro(err);
      }
    );
  }

  fechar() {
    this.dialogRef.close();
  }

  criarNovaExcecao() {
    const largura = Number(($('body').width()));
    let dialogRef;
    const config = {
      width: largura > 930 ? '900px' : $('body').width().toString() + 'px',
      data: { editando: false, categoriaExclusiva: 2 },
      panelClass: 'modal-card',
      maxHeight: '98vh'
    };

    if (this.premissasSistema.filtroProduto === TipoFiltroProduto.Agrupamento) {
      dialogRef = this.dialog.open(SelecionaProdutoModalComponent, config);
    } else {
      dialogRef = this.dialog.open(SelecionaProdutoV2ModalComponent, config);
    }

    dialogRef.afterClosed().subscribe(result => {
      if (result) {

        if (this.excecoes.some(p => p.idProduto === result.produtoTela.idProduto)) {
          swal({
            title: 'ATENÇÃO!!!',
            html: 'Já existe uma exceção para esse painel!!!',
            buttonsStyling: false,
            confirmButtonClass: 'btn btn-warning',
            type: 'warning'
          }).catch(swal.noop);
        } else {
          this.novaExcecao = new ExcecaoIndicadorAnaliseDesconto();
          this.novaExcecao.idProduto = result.produtoTela.idProduto;
          this.novaExcecao.descricao = result.produtoTela.descricao;
          this.novaExcecao.indicadores = [
            { id: 0, descricao: 'Bloqueio Automático da Autorização', de: -100, ate: 1.20, cor: 'vermelho', editando: false, idProduto: this.novaExcecao.idProduto },
            { id: 0, descricao: 'Permite a aprovação, mas exige o anexo do orçamento do concorrente e uma justificativa descritiva', de: 1.201, ate: 1.301, cor: 'amarelo', editando: false, idProduto: this.novaExcecao.idProduto },
            { id: 0, descricao: 'Liberação imediata para execução', de: 1.302, ate: 100, cor: 'verde', editando: false, idProduto: this.novaExcecao.idProduto }
          ];
        }
      }
    });
  }
}
